module.exports = __webpack_public_path__ + "img/C106.272fa8cf.png";